import React, { useContext } from "react";
import styled from "styled-components";
import { Button } from "../../Button";
import { Icon } from "../../Icon";
import { Tooltip } from "../../Tooltip";
import { FormFieldGroupContext } from "../FormFieldGroup";
import { GenericFormContext } from "../GenericFormContext";
import { FormRepeatedGroupContext } from "./FormRepeatedGroup";
const GridStyledButton = styled(Button) `
  grid-column: ${(props) => `${props.column}/${props.column}`};
`;
/**
 * A common implementation for a button control in a FormRepeatedGroup field group that
 * aligns the buttons according to the design system layout.
 */
const RepeatedGroupButton = ({ label, onClick, children, column }) => {
    const { disabled: fieldGroupIsDisabled } = useContext(FormFieldGroupContext);
    const { editIsAllowed } = useContext(GenericFormContext);
    const buttonIsDisabled = fieldGroupIsDisabled === true || editIsAllowed === false;
    return (React.createElement(Tooltip, { content: label, placement: "top" },
        React.createElement(GridStyledButton, { column: column, disabled: buttonIsDisabled, onClick: onClick, size: "noPadding", textStyle: "greyIcon", type: "button", variant: "iconWithoutBorder", "data-trackid": label }, children)));
};
/**
 * "Add" control for adding a new field group to FormRepeatedGroup. Does not render if the current
 * number of field groups is greater-or-equal-to the maximum number of groups specified for the
 * FormRepeatedGroup
 */
export const RepeatedGroupAddButton = ({ index, label }) => {
    const { insertField, maxGroups, numGroups } = useContext(FormRepeatedGroupContext);
    if (maxGroups && numGroups >= maxGroups)
        return null;
    return (React.createElement(RepeatedGroupButton, { column: 2, label: label, onClick: () => insertField(index + 1) },
        React.createElement(Icon, { size: "13px", src: "Add" })));
};
/**
 * "Remove" control for removing a field group from a FormRepeatedGroup. Does not render if the current
 * number of field groups is less-than-or-equal-to the minimum number of groups specified for the
 * FormRepeatedGroup.
 */
export const RepeatedGroupTrashButton = ({ index, label }) => {
    const { minGroups, numGroups, remove } = useContext(FormRepeatedGroupContext);
    if (minGroups && numGroups <= minGroups)
        return null;
    return (React.createElement(RepeatedGroupButton, { column: 1, label: label, onClick: () => remove(index) },
        React.createElement(Icon, { size: "16px", src: "Trash" })));
};
/**
 * "Move field up" control for moving a field up in the order of the field groups in a
 * FormRepeatedGroup. Does not render for the first field group.
 */
export const RepeatedGroupUpButton = ({ index, label }) => {
    const { swap } = useContext(FormRepeatedGroupContext);
    if (index === 0)
        return null;
    return (React.createElement(RepeatedGroupButton, { column: 3, label: label, onClick: () => swap(index, index - 1) },
        React.createElement(Icon, { size: "13px", src: "ArrowUp" })));
};
/**
 * "Move field down" control for moving a field down in the order of the field groups in a
 * FormRepeatedGroup. Does not render for the last field group.
 */
export const RepeatedGroupDownButton = ({ index, label }) => {
    const { numGroups, swap } = useContext(FormRepeatedGroupContext);
    if (index + 1 >= numGroups)
        return null;
    return (React.createElement(RepeatedGroupButton, { column: 4, label: label, onClick: () => swap(index, index + 1) },
        React.createElement(Icon, { size: "13px", src: "ArrowDown" })));
};
